import React from "react";
import { Spinner } from "reactstrap";
import styled from "styled-components";
import XCard from "./XCard";

const LoadingCardBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const LoadingCardText = styled.div`
  color: #4e73df !important;
  font-size: 20px;
  font-weight: bold;
  margin-left: 20px;
`;

function LoadingCard({ title }) {
  return (
    <XCard title={title}>
      <LoadingCardBody>
        <Spinner color="primary" />
        <LoadingCardText>Loading</LoadingCardText>
      </LoadingCardBody>
    </XCard>
  );
}

export default LoadingCard;
